import React from 'react'
import { upArrow } from '../../assets'

function BackToTop() {
  const [position, setPosition] = React.useState({top: 0, left: 0})
  React.useEffect(() => {
    window.scroll({
      top: position.top,
      left: position.left,
      behavior: 'smooth'
    })
  })
   
  const scrollTop = React.useRef()
   React.useEffect(( ) => {
     window.addEventListener('scroll', (e) => {
      window.scrollY > 200 
      ? scrollTop.current.style.display = 'inline-block'
      : scrollTop.current.style.display = 'none'
    })
   }) 
 
  return (
    <>
      <span 
        onClick={() => setPosition({...position, position: {top: 0, left: 0}})} 
        className="circle"
        ref={scrollTop}
      ><img src={upArrow} alt="upArrow" width="24px" height="24px"/></span>
    </>
  )
}

export default BackToTop